import { computed } from 'vue';
import { useStore } from 'vuex';

export function useTotalDonations() {
  const store = useStore();

  const totalDonations = computed(() => store.state.donations.totalDonations);

  const hasDonations = computed(() => {
    if (Array.isArray(totalDonations.value)) {
      return !!totalDonations.value.length;
    }

    return !!totalDonations.value;
  });

  const hasSingleDonations = computed(() => {
    return hasDonations.value && totalDonations.value.amount;
  });

  const hasRecurringDonations = computed(() => {
    return (
      hasDonations.value &&
      parseInt(totalDonations.value.recurringDonationsCount) > 0
    );
  });

  const treesCount = computed(() => {
    let count = 1;

    if (hasDonations.value) {
      count = count + totalDonations.value.count;
    }

    return count;
  });

  return {
    totalDonations,
    hasDonations,
    hasSingleDonations,
    hasRecurringDonations,
    treesCount,
  };
}
